import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/blog',
    component: ComponentCreator('/blog', 'bfc'),
    exact: true
  },
  {
    path: '/blog/archive',
    component: ComponentCreator('/blog/archive', '182'),
    exact: true
  },
  {
    path: '/blog/releases/1.0',
    component: ComponentCreator('/blog/releases/1.0', 'f3f'),
    exact: true
  },
  {
    path: '/search',
    component: ComponentCreator('/search', '5de'),
    exact: true
  },
  {
    path: '/docs',
    component: ComponentCreator('/docs', '2ef'),
    routes: [
      {
        path: '/docs',
        component: ComponentCreator('/docs', '035'),
        routes: [
          {
            path: '/docs',
            component: ComponentCreator('/docs', '8ec'),
            routes: [
              {
                path: '/docs/basics/',
                component: ComponentCreator('/docs/basics/', '77c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/basics/working-with-images',
                component: ComponentCreator('/docs/basics/working-with-images', 'e44'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/basics/working-with-masks',
                component: ComponentCreator('/docs/basics/working-with-masks', 'b71'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/basics/working-with-rois',
                component: ComponentCreator('/docs/basics/working-with-rois', '790'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/',
                component: ComponentCreator('/docs/features/', '734'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/comparison/',
                component: ComponentCreator('/docs/features/comparison/', 'f4c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/comparison/addition',
                component: ComponentCreator('/docs/features/comparison/addition', 'cd3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/comparison/hypotenuse',
                component: ComponentCreator('/docs/features/comparison/hypotenuse', '756'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/comparison/logical-conjunction',
                component: ComponentCreator('/docs/features/comparison/logical-conjunction', 'e36'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/comparison/logical-disjunction',
                component: ComponentCreator('/docs/features/comparison/logical-disjunction', 'cb2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/comparison/subtraction',
                component: ComponentCreator('/docs/features/comparison/subtraction', '3e6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/filters/',
                component: ComponentCreator('/docs/features/filters/', '26b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/filters/blur',
                component: ComponentCreator('/docs/features/filters/blur', '8f5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/filters/derivative',
                component: ComponentCreator('/docs/features/filters/derivative', 'ada'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/filters/gaussian-blur',
                component: ComponentCreator('/docs/features/filters/gaussian-blur', 'a30'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/filters/gradient',
                component: ComponentCreator('/docs/features/filters/gradient', '4a9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/filters/grayscale',
                component: ComponentCreator('/docs/features/filters/grayscale', 'f9f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/filters/invert',
                component: ComponentCreator('/docs/features/filters/invert', '708'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/filters/level',
                component: ComponentCreator('/docs/features/filters/level', 'c0d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/filters/median',
                component: ComponentCreator('/docs/features/filters/median', 'ec7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/filters/pixelate',
                component: ComponentCreator('/docs/features/filters/pixelate', '462'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/geometry/',
                component: ComponentCreator('/docs/features/geometry/', 'd7a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/geometry/flip',
                component: ComponentCreator('/docs/features/geometry/flip', '60e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/geometry/get-perspective-warp-matrix',
                component: ComponentCreator('/docs/features/geometry/get-perspective-warp-matrix', '6f4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/geometry/resize',
                component: ComponentCreator('/docs/features/geometry/resize', 'deb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/geometry/rotate',
                component: ComponentCreator('/docs/features/geometry/rotate', 'ca1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/geometry/transform',
                component: ComponentCreator('/docs/features/geometry/transform', 'fea'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/geometry/transform-and-rotate',
                component: ComponentCreator('/docs/features/geometry/transform-and-rotate', '9ce'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/morphology/',
                component: ComponentCreator('/docs/features/morphology/', 'c17'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/morphology/bottom-hat',
                component: ComponentCreator('/docs/features/morphology/bottom-hat', '280'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/morphology/canny-edge-detector',
                component: ComponentCreator('/docs/features/morphology/canny-edge-detector', 'ca2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/morphology/closing',
                component: ComponentCreator('/docs/features/morphology/closing', 'c5d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/morphology/dilation',
                component: ComponentCreator('/docs/features/morphology/dilation', 'c9b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/morphology/erosion',
                component: ComponentCreator('/docs/features/morphology/erosion', '61a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/morphology/morphological-gradient',
                component: ComponentCreator('/docs/features/morphology/morphological-gradient', '5ad'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/morphology/opening',
                component: ComponentCreator('/docs/features/morphology/opening', '951'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/morphology/top-hat',
                component: ComponentCreator('/docs/features/morphology/top-hat', 'e99'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/operations/',
                component: ComponentCreator('/docs/features/operations/', '8ed'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/operations/clear-border',
                component: ComponentCreator('/docs/features/operations/clear-border', 'b0e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/operations/get-extrema',
                component: ComponentCreator('/docs/features/operations/get-extrema', '38c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/operations/paint-mask',
                component: ComponentCreator('/docs/features/operations/paint-mask', 'ed6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/operations/remove-points',
                component: ComponentCreator('/docs/features/operations/remove-points', '2b9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/operations/threshold',
                component: ComponentCreator('/docs/features/operations/threshold', 'ca4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/operations/watershed',
                component: ComponentCreator('/docs/features/operations/watershed', '800'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/regions-of-interest/',
                component: ComponentCreator('/docs/features/regions-of-interest/', '311'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/regions-of-interest/centroid',
                component: ComponentCreator('/docs/features/regions-of-interest/centroid', '3b0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/regions-of-interest/convex-hull',
                component: ComponentCreator('/docs/features/regions-of-interest/convex-hull', '5b9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/regions-of-interest/ellipse',
                component: ComponentCreator('/docs/features/regions-of-interest/ellipse', 'efb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/regions-of-interest/eqpc',
                component: ComponentCreator('/docs/features/regions-of-interest/eqpc', '223'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/regions-of-interest/feret-diameters',
                component: ComponentCreator('/docs/features/regions-of-interest/feret-diameters', '198'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/regions-of-interest/fill-ratio',
                component: ComponentCreator('/docs/features/regions-of-interest/fill-ratio', '090'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/regions-of-interest/holes-info',
                component: ComponentCreator('/docs/features/regions-of-interest/holes-info', 'd69'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/regions-of-interest/mbr',
                component: ComponentCreator('/docs/features/regions-of-interest/mbr', '252'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/regions-of-interest/ped',
                component: ComponentCreator('/docs/features/regions-of-interest/ped', '317'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/regions-of-interest/perimeter',
                component: ComponentCreator('/docs/features/regions-of-interest/perimeter', 'c68'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/regions-of-interest/roundness',
                component: ComponentCreator('/docs/features/regions-of-interest/roundness', 'c51'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/regions-of-interest/solidity',
                component: ComponentCreator('/docs/features/regions-of-interest/solidity', 'b4e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/features/regions-of-interest/sphericity',
                component: ComponentCreator('/docs/features/regions-of-interest/sphericity', '7ec'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/getting-started',
                component: ComponentCreator('/docs/getting-started', '54c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/glossary',
                component: ComponentCreator('/docs/glossary', 'a11'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorials/',
                component: ComponentCreator('/docs/tutorials/', '610'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorials/applying-transform-function-on-images',
                component: ComponentCreator('/docs/tutorials/applying-transform-function-on-images', 'c65'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorials/correcting-baseline-with-tophat',
                component: ComponentCreator('/docs/tutorials/correcting-baseline-with-tophat', '3be'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorials/extracting-metadata',
                component: ComponentCreator('/docs/tutorials/extracting-metadata', '157'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorials/image-segmentation-with-threshold',
                component: ComponentCreator('/docs/tutorials/image-segmentation-with-threshold', '578'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorials/image-segmentation-with-watershed',
                component: ComponentCreator('/docs/tutorials/image-segmentation-with-watershed', '16a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorials/image-stack-analysis',
                component: ComponentCreator('/docs/tutorials/image-stack-analysis', 'fbf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/tutorials/roi-analysis',
                component: ComponentCreator('/docs/tutorials/roi-analysis', '44e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/useful-tips/',
                component: ComponentCreator('/docs/useful-tips/', '5ac'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/useful-tips/blurring-techniques-and-their-differences',
                component: ComponentCreator('/docs/useful-tips/blurring-techniques-and-their-differences', 'acd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/useful-tips/out-parameter-and-its-purpose',
                component: ComponentCreator('/docs/useful-tips/out-parameter-and-its-purpose', '045'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/useful-tips/plain-call-vs-method-call',
                component: ComponentCreator('/docs/useful-tips/plain-call-vs-method-call', '57b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/useful-tips/transform-function-and-its-parameters',
                component: ComponentCreator('/docs/useful-tips/transform-function-and-its-parameters', '9c8'),
                exact: true,
                sidebar: "tutorialSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: ComponentCreator('/', 'e5f'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
